module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#user",
      toString: function () {
        return this.url;
      }
    }